import { render } from "./ProviderView.vue?vue&type=template&id=c7e984e4"
import script from "./ProviderView.vue?vue&type=script&lang=js"
export * from "./ProviderView.vue?vue&type=script&lang=js"

import exportComponent from "/opt/apps/acquiring_front_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__